<div class="toggleswitch">
  <input
    type="checkbox"
    name="toggleswitch"
    class="toggleswitch-checkbox"
    [ngModel]="value"
    (ngModelChange)="updateValue($event)"
    [id]="id"
  />
  <label class="toggleswitch-label" [for]="id">
    <span
      [ngClass]="value ? 'toggleswitch-inner-in' : 'toggleswitch-inner-off'"
      >{{ value ? onLabel : offLabel }}</span
    >
    <span class="toggleswitch-switch"></span>
  </label>
</div>
